import rms from "../services/rmsService";
import { ActionTypes } from "../constants";
import { asyncAction, asyncCall } from "./commonActions";

export const getAppraisees = (appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_RMS_APPRAISEES_REQUEST,
            success: ActionTypes.GET_RMS_APPRAISEES_SUCCESS,
            failure: ActionTypes.GET_RMS_APPRAISEES_FAILURE,
        },
        serviceAction: rms.getAppraisees,
        appCode,
    });

export const getAppraiseeDetails = (uuid, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_RMS_APPRAISEE_REQUEST,
            success: ActionTypes.GET_RMS_APPRAISEE_SUCCESS,
            failure: ActionTypes.GET_RMS_APPRAISEE_FAILURE,
        },
        serviceAction: rms.getAppraiseeDetails,
        appCode,
        uuid,
    });

export const getAppraisers = (appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_RMS_APPRAISERS_REQUEST,
            success: ActionTypes.GET_RMS_APPRAISERS_SUCCESS,
            failure: ActionTypes.GET_RMS_APPRAISERS_FAILURE,
        },
        serviceAction: rms.getAppraisers,
        appCode,
    });

export const getAppraisals = (appCode, suppressErrors = false) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_RMS_APPRAISALS_REQUEST,
            success: ActionTypes.GET_RMS_APPRAISALS_SUCCESS,
            failure: ActionTypes.GET_RMS_APPRAISALS_FAILURE,
        },
        serviceAction: rms.getAppraisals,
        appCode,
        suppressErrors,
    });

export const getAppraisalDetails = (id, appCode, params) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_RMS_APPRAISAL_DETAILS_REQUEST,
            success: ActionTypes.GET_RMS_APPRAISAL_DETAILS_SUCCESS,
            failure: ActionTypes.GET_RMS_APPRAISAL_DETAILS_FAILURE,
        },
        serviceAction: rms.getAppraisalDetails,
        appCode,
        id,
        params,
    });

export const initiateAppraisal = (appCode, params, callback = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.ADD_RMS_APPRAISAL_INIT_REQUEST,
            success: ActionTypes.ADD_RMS_APPRAISAL_INIT_SUCCESS,
            failure: ActionTypes.ADD_RMS_APPRAISAL_INIT_FAILURE,
        },
        serviceAction: rms.initAppraisal,
        appCode,
        params,
        callback,
    });

export const addAppraisal = (appCode, params) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.ADD_RMS_APPRAISAL_REQUEST,
            success: ActionTypes.ADD_RMS_APPRAISAL_SUCCESS,
            failure: ActionTypes.ADD_RMS_APPRAISAL_FAILURE,
        },
        serviceAction: rms.addAppraisal,
        appCode,
        params,
    });

export const updateAppraisal = (appCode, id, params) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_RMS_APPRAISAL_REQUEST,
            success: ActionTypes.UPDATE_RMS_APPRAISAL_SUCCESS,
            failure: ActionTypes.UPDATE_RMS_APPRAISAL_FAILURE,
        },
        serviceAction: rms.updateAppraisal,
        appCode,
        id,
        params,
    });

export const addAppraisalForm = (appCode, id, params, callback = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.ADD_RMS_APPRAISAL_FORM_REQUEST,
            success: ActionTypes.ADD_RMS_APPRAISAL_FORM_SUCCESS,
            failure: ActionTypes.ADD_RMS_APPRAISAL_FORM_FAILURE,
        },
        serviceAction: rms.addAppraisalForm,
        appCode,
        id,
        params,
        callback,
    });

export const updateAppraisalForm = (appCode, id, formId, params, callback = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_RMS_APPRAISAL_FORM_REQUEST,
            success: ActionTypes.UPDATE_RMS_APPRAISAL_FORM_SUCCESS,
            failure: ActionTypes.UPDATE_RMS_APPRAISAL_FORM_FAILURE,
        },
        serviceAction: rms.updateAppraisalForm,
        appCode,
        id,
        formId,
        params,
        callback,
    });

export const updateAppraisalFormElement = (id, params, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_RMS_APPRAISAL_FORM_ELEMENT_REQUEST,
            success: ActionTypes.UPDATE_RMS_APPRAISAL_FORM_ELEMENT_SUCCESS,
            failure: ActionTypes.UPDATE_RMS_APPRAISAL_FORM_ELEMENT_FAILURE,
        },
        serviceAction: rms.updateAppraisalFormElement,
        appCode,
        id,
        params,
    });

export const getActivities = (appCode, searchString = null, skip = null, limit = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_ACTIVITIES_REQUEST,
            success: ActionTypes.GET_ACTIVITIES_SUCCESS,
            failure: ActionTypes.GET_ACTIVITIES_FAILURE,
        },
        serviceAction: rms.getActivities,
        appCode,
        searchString,
        skip,
        limit,
    });

export const getActivityDetails = (id, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_ACTIVITY_REQUEST,
            success: ActionTypes.GET_ACTIVITY_SUCCESS,
            failure: ActionTypes.GET_ACTIVITY_FAILURE,
        },
        serviceAction: rms.getActivityDetails,
        appCode,
        id,
    });

export const addActivity = (appCode, params, appraisalId = null, inputSegmentId = null, callback = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.ADD_ACTIVITY_REQUEST,
            success: ActionTypes.ADD_ACTIVITY_SUCCESS,
            failure: ActionTypes.ADD_ACTIVITY_FAILURE,
        },
        serviceAction: rms.addActivity,
        appCode,
        params,
        appraisalId,
        inputSegmentId,
        callback
    });

export const updateActivity = (appCode, id, params) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_ACTIVITY_REQUEST,
            success: ActionTypes.UPDATE_ACTIVITY_SUCCESS,
            failure: ActionTypes.UPDATE_ACTIVITY_FAILURE,
        },
        serviceAction: rms.updateActivity,
        appCode,
        id,
        params,
    });

export const deleteActivity = (appCode, id) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.DELETE_ACTIVITY_REQUEST,
            success: ActionTypes.DELETE_ACTIVITY_SUCCESS,
            failure: ActionTypes.DELETE_ACTIVITY_FAILURE,
        },
        serviceAction: rms.deleteActivity,
        appCode,
        id,
    });

export const getActivityTypes = (appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_ACTIVITY_TYPES_REQUEST,
            success: ActionTypes.GET_ACTIVITY_TYPES_SUCCESS,
            failure: ActionTypes.GET_ACTIVITY_TYPES_FAILURE,
        },
        serviceAction: rms.getActivityTypes,
        appCode,
    });

export const getNotes = (appCode, searchString = null, skip = null, limit = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_NOTES_REQUEST,
            success: ActionTypes.GET_NOTES_SUCCESS,
            failure: ActionTypes.GET_NOTES_FAILURE,
        },
        serviceAction: rms.getResources,
        appCode,
        searchString,
        skip,
        limit,
        type: "note",
    });

export const getNoteDetails = (id, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_NOTE_REQUEST,
            success: ActionTypes.GET_NOTE_SUCCESS,
            failure: ActionTypes.GET_NOTE_FAILURE,
        },
        serviceAction: rms.getResourceDetails,
        appCode,
        id,
    });

export const addNote = (appCode, title, description) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.ADD_NOTE_REQUEST,
            success: ActionTypes.ADD_NOTE_SUCCESS,
            failure: ActionTypes.ADD_NOTE_FAILURE,
        },
        serviceAction: rms.addResource,
        appCode,
        title,
        description,
        type: "note",
    });

export const updateNote = (appCode, id, title, description) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_NOTE_REQUEST,
            success: ActionTypes.UPDATE_NOTE_SUCCESS,
            failure: ActionTypes.UPDATE_NOTE_FAILURE,
        },
        serviceAction: rms.updateResource,
        appCode,
        id,
        title,
        description,
    });

export const deleteNote = (id, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.DELETE_NOTE_REQUEST,
            success: ActionTypes.DELETE_NOTE_SUCCESS,
            failure: ActionTypes.DELETE_NOTE_FAILURE,
        },
        serviceAction: rms.deleteResource,
        appCode,
        id,
    });

export const getPDPs = (appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_PDPS_REQUEST,
            success: ActionTypes.GET_PDPS_SUCCESS,
            failure: ActionTypes.GET_PDPS_FAILURE,
        },
        serviceAction: rms.getPDPs,
        appCode,
    });

export const getPDPDetails = (id, appCode, params) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_PDP_REQUEST,
            success: ActionTypes.GET_PDP_SUCCESS,
            failure: ActionTypes.GET_PDP_FAILURE,
        },
        serviceAction: rms.getPDPDetails,
        appCode,
        id,
        params,
    });

export const updatePDP = (appCode, id, params) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_PDP_REQUEST,
            success: ActionTypes.UPDATE_PDP_SUCCESS,
            failure: ActionTypes.UPDATE_PDP_FAILURE,
        },
        serviceAction: rms.updatePDP,
        appCode,
        id,
        params,
    });

export const deletePDP = (id, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.DELETE_PDP_REQUEST,
            success: ActionTypes.DELETE_PDP_SUCCESS,
            failure: ActionTypes.DELETE_PDP_FAILURE,
        },
        serviceAction: rms.deletePDP,
        appCode,
        id,
    });

export const getQualifications = (appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_QUALIFICATIONS_REQUEST,
            success: ActionTypes.GET_QUALIFICATIONS_SUCCESS,
            failure: ActionTypes.GET_QUALIFICATIONS_FAILURE,
        },
        serviceAction: rms.getQualifications,
        appCode,
    });

export const getQualificationDetails = (id, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_QUALIFICATION_REQUEST,
            success: ActionTypes.GET_QUALIFICATION_SUCCESS,
            failure: ActionTypes.GET_QUALIFICATION_FAILURE,
        },
        serviceAction: rms.getQualification,
        appCode,
        id,
    });

export const addQualification = (appCode, params, appraisalId = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.ADD_QUALIFICATION_REQUEST,
            success: ActionTypes.ADD_QUALIFICATION_SUCCESS,
            failure: ActionTypes.ADD_QUALIFICATION_FAILURE,
        },
        serviceAction: rms.addQualification,
        appCode,
        params,
        appraisalId,
    });

export const updateQualification = (id, params, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_QUALIFICATION_REQUEST,
            success: ActionTypes.UPDATE_QUALIFICATION_SUCCESS,
            failure: ActionTypes.UPDATE_QUALIFICATION_FAILURE,
        },
        serviceAction: rms.updateQualification,
        appCode,
        id,
        params,
    });

export const deleteQualification = (id, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.DELETE_QUALIFICATION_REQUEST,
            success: ActionTypes.DELETE_QUALIFICATION_SUCCESS,
            failure: ActionTypes.DELETE_QUALIFICATION_FAILURE,
        },
        serviceAction: rms.deleteQualification,
        appCode,
        id,
    });

export const getResources = (appCode, searchString = null, skip = null, limit = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_RESOURCES_REQUEST,
            success: ActionTypes.GET_RESOURCES_SUCCESS,
            failure: ActionTypes.GET_RESOURCES_FAILURE,
        },
        serviceAction: rms.getResources,
        appCode,
        searchString,
        skip,
        limit,
        type: "file",
    });

export const getResourceDetails = (id, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_RESOURCE_DETAILS_REQUEST,
            success: ActionTypes.GET_RESOURCE_DETAILS_SUCCESS,
            failure: ActionTypes.GET_RESOURCE_DETAILS_FAILURE,
        },
        serviceAction: rms.getResourceDetails,
        appCode,
        id,
    });

export const downloadResource = (appCode, url, onSuccess) => {
    const serviceFunction = async (accessToken) => {
        rms.downloadResource({ appCode, url, accessToken }).then((blob) =>
            onSuccess(blob)
        );
    };

    return asyncCall(appCode, serviceFunction);
};

export const addResource = (appCode, title, description, file) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.ADD_RESOURCE_REQUEST,
            success: ActionTypes.ADD_RESOURCE_SUCCESS,
            failure: ActionTypes.ADD_RESOURCE_FAILURE,
        },
        serviceAction: rms.addResource,
        appCode,
        title,
        description,
        type: "file",
        file,
    });

export const updateResource = (appCode, id, title, description) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_RESOURCE_REQUEST,
            success: ActionTypes.UPDATE_RESOURCE_SUCCESS,
            failure: ActionTypes.UPDATE_RESOURCE_FAILURE,
        },
        serviceAction: rms.updateResource,
        appCode,
        id,
        title,
        description,
    });

export const deleteResource = (id, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.DELETE_RESOURCE_REQUEST,
            success: ActionTypes.DELETE_RESOURCE_SUCCESS,
            failure: ActionTypes.DELETE_RESOURCE_FAILURE,
        },
        serviceAction: rms.deleteResource,
        appCode,
        id,
    });

export const getCategories = (appCode, searchString = null, skip = null, limit = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_CATEGORIES_REQUEST,
            success: ActionTypes.GET_CATEGORIES_SUCCESS,
            failure: ActionTypes.GET_CATEGORIES_FAILURE,
        },
        serviceAction: rms.getCategories,
        appCode,
        searchString,
        skip,
        limit,
    });

export const getContacts = (appCode, searchText = null, limit = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_CONTACTS_REQUEST,
            success: ActionTypes.GET_CONTACTS_SUCCESS,
            failure: ActionTypes.GET_CONTACTS_FAILURE,
        },
        serviceAction: rms.getContacts,
        appCode,
        searchText,
        limit,
    });

export const getMessages = (folder, appCode, searchString = null, skip = null, limit = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_MESSAGES_REQUEST,
            success: ActionTypes.GET_MESSAGES_SUCCESS,
            failure: ActionTypes.GET_MESSAGES_FAILURE,
        },
        serviceAction: rms.getMessages,
        appCode,
        folder,
        searchString,
        skip,
        limit,
    });

export const getMessageDetails = (id, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_MESSAGE_REQUEST,
            success: ActionTypes.GET_MESSAGE_SUCCESS,
            failure: ActionTypes.GET_MESSAGE_FAILURE,
        },
        serviceAction: rms.getMessageDetails,
        appCode,
        id,
    });

export const addMessage = (appCode, params, callback) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.ADD_MESSAGE_REQUEST,
            success: ActionTypes.ADD_MESSAGE_SUCCESS,
            failure: ActionTypes.ADD_MESSAGE_FAILURE,
        },
        serviceAction: rms.addMessage,
        appCode,
        params,
        callback,
    });

export const updateMessage = (id, params, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_MESSAGE_REQUEST,
            success: ActionTypes.UPDATE_MESSAGE_SUCCESS,
            failure: ActionTypes.UPDATE_MESSAGE_FAILURE,
        },
        serviceAction: rms.updateMessage,
        appCode,
        id,
        params,
    });

export const deleteMessage = (appCode, id) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.DELETE_MESSAGE_REQUEST,
            success: ActionTypes.DELETE_MESSAGE_SUCCESS,
            failure: ActionTypes.DELETE_MESSAGE_FAILURE,
        },
        serviceAction: rms.deleteMessage,
        appCode,
        id,
    });

export const getNotifications = (appCode, searchString = null, skip = null, limit = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_NOTIFICATIONS_REQUEST,
            success: ActionTypes.GET_NOTIFICATIONS_SUCCESS,
            failure: ActionTypes.GET_NOTIFICATIONS_FAILURE,
        },
        serviceAction: rms.getNotifications,
        appCode,
        searchString,
        skip,
        limit,
    });

export const getNotificationDetails = (id, appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_NOTIFICATION_REQUEST,
            success: ActionTypes.GET_NOTIFICATION_SUCCESS,
            failure: ActionTypes.GET_NOTIFICATION_FAILURE,
        },
        serviceAction: rms.getNotificationDetails,
        appCode,
        id,
    });

export const getScopeOfWorkDetails = (id, appCode, appraisalId = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_SCOPE_OF_WORK_REQUEST,
            success: ActionTypes.GET_SCOPE_OF_WORK_SUCCESS,
            failure: ActionTypes.GET_SCOPE_OF_WORK_FAILURE,
        },
        serviceAction: rms.getScopeOfWorkDetails,
        appCode,
        id,
        appraisalId,
    });

export const addScopeOfWork = (appCode, params, appraisalId, callback = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.ADD_SCOPE_OF_WORK_REQUEST,
            success: ActionTypes.ADD_SCOPE_OF_WORK_SUCCESS,
            failure: ActionTypes.ADD_SCOPE_OF_WORK_FAILURE,
        },
        serviceAction: rms.addScopeOfWork,
        appCode,
        params,
        appraisalId,
        callback,
    });

export const updateScopeOfWork = (appCode, id, params, appraisalId = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_SCOPE_OF_WORK_REQUEST,
            success: ActionTypes.UPDATE_SCOPE_OF_WORK_SUCCESS,
            failure: ActionTypes.UPDATE_SCOPE_OF_WORK_FAILURE,
        },
        serviceAction: rms.updateScopeOfWork,
        appCode,
        id,
        params,
        appraisalId,
    });

export const deleteScopeOfWork = (appCode, id, appraisalId = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.DELETE_SCOPE_OF_WORK_REQUEST,
            success: ActionTypes.DELETE_SCOPE_OF_WORK_SUCCESS,
            failure: ActionTypes.DELETE_SCOPE_OF_WORK_FAILURE,
        },
        serviceAction: rms.deleteScopeOfWork,
        appCode,
        id,
        appraisalId,
    });

export const getDevelopmentNeeds = (appCode, searchString = null, skip = null, limit = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_DEVELOPMENT_NEEDS_REQUEST,
            success: ActionTypes.GET_DEVELOPMENT_NEEDS_SUCCESS,
            failure: ActionTypes.GET_DEVELOPMENT_NEEDS_FAILURE,
        },
        serviceAction: rms.getDevelopmentNeeds,
        appCode,
        searchString,
        skip,
        limit,
        type: "file",
    });

export const getDevelopmentNeed = (id, appCode, appraisalId = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_DEVELOPMENT_NEED_REQUEST,
            success: ActionTypes.GET_DEVELOPMENT_NEED_SUCCESS,
            failure: ActionTypes.GET_DEVELOPMENT_NEED_FAILURE,
        },
        serviceAction: rms.getDevelopmentNeed,
        appCode,
        id,
        appraisalId,
    });

export const addDevelopmentNeed = (appCode, params, appraisalId = null, callback) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.ADD_DEVELOPMENT_NEED_REQUEST,
            success: ActionTypes.ADD_DEVELOPMENT_NEED_SUCCESS,
            failure: ActionTypes.ADD_DEVELOPMENT_NEED_FAILURE,
        },
        serviceAction: rms.addDevelopmentNeed,
        appCode,
        params,
        appraisalId,
        callback
    });

export const updateDevelopmentNeed = (appCode, id, params, appraisalId = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_DEVELOPMENT_NEED_REQUEST,
            success: ActionTypes.UPDATE_DEVELOPMENT_NEED_SUCCESS,
            failure: ActionTypes.UPDATE_DEVELOPMENT_NEED_FAILURE,
        },
        serviceAction: rms.updateDevelopmentNeed,
        appCode,
        id,
        params,
        appraisalId,
    });

export const deleteDevelopmentNeed = (appCode, id, appraisalId = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.DELETE_DEVELOPMENT_NEED_REQUEST,
            success: ActionTypes.DELETE_DEVELOPMENT_NEED_SUCCESS,
            failure: ActionTypes.DELETE_DEVELOPMENT_NEED_FAILURE,
        },
        serviceAction: rms.deleteDevelopmentNeed,
        appCode,
        id,
        appraisalId,
    });

export const getTasks = (appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_TASKS_REQUEST,
            success: ActionTypes.GET_TASKS_SUCCESS,
            failure: ActionTypes.GET_TASKS_FAILURE,
        },
        serviceAction: rms.getTasks,
        appCode,
    });

export const getTerms = (appCode) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.GET_TERMS_REQUEST,
            success: ActionTypes.GET_TERMS_SUCCESS,
            failure: ActionTypes.GET_TERMS_FAILURE,
        },
        serviceAction: rms.getTerms,
        appCode,
    });

export const updateTerm = (id, params, appCode, callback = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_TERM_REQUEST,
            success: ActionTypes.UPDATE_TERM_SUCCESS,
            failure: ActionTypes.UPDATE_TERM_FAILURE,
        },
        serviceAction: rms.updateTerm,
        appCode,
        id,
        params,
        callback,
    });

export const updateSurvey = (id, params, appCode, callback = null) =>
    asyncAction({
        actionTypes: {
            request: ActionTypes.UPDATE_RMS_SURVEY_REQUEST,
            success: ActionTypes.UPDATE_RMS_SURVEY_SUCCESS,
            failure: ActionTypes.UPDATE_RMS_SURVEY_FAILURE,
        },
        serviceAction: rms.updateSurvey,
        appCode,
        id,
        params,
        callback,
    });

const rmsActions = {
    getActivities,
    getActivityDetails,
    addActivity,
    updateActivity,
    deleteActivity,
    getDevelopmentNeed,
    getDevelopmentNeeds,
    addDevelopmentNeed,
    updateDevelopmentNeed,
    deleteDevelopmentNeed,
    getActivityTypes,
    getAppraisees,
    getAppraiseeDetails,
    getAppraisers,
    getAppraisals,
    getAppraisalDetails,
    addAppraisal,
    updateAppraisal,
    addAppraisalForm,
    updateAppraisalForm,
    updateAppraisalFormElement,
    getCategories,
    getContacts,
    getMessages,
    getMessageDetails,
    addMessage,
    updateMessage,
    deleteMessage,
    getNotes,
    getNoteDetails,
    deleteNote,
    getNotifications,
    getNotificationDetails,
    getPDPs,
    getQualifications,
    getQualificationDetails,
    addQualification,
    updateQualification,
    deleteQualification,
    getResources,
    getResourceDetails,
    downloadResource,
    addResource,
    deleteResource,
    getScopeOfWorkDetails,
    addScopeOfWork,
    updateScopeOfWork,
    deleteScopeOfWork,
    getTasks,
    getTerms,
    updateTerm,
    updateSurvey,
};

export default rmsActions;
